module.exports = __webpack_public_path__ + "img/grey-academy-achieve.5baa8995.png";